export default "__VITE_ASSET__2ac49b5c__"